<template>
  <div data-test="base-campus-add">
    <van-form class="vf" ref="form"
      input-align="right" 
      :show-error="false" 
      :show-error-message="false">
      <van-field
        required
        v-model="campus.name"
        label="校区名字"
        :formatter="(v)=>v.trimLeft()"
        name="name"
        placeholder="请输入校区名字"
        maxlength="20"
        :clearable="true"
        :rules="[{ required: true, message: '请输入校区名字' }]"
      />
      <van-field
        v-model="campus.contactName"
        label="联系人"
        :formatter="(v)=>v.trimLeft()"
        placeholder="请输入校区联系人名称"
        maxlength="20"
        :clearable="true"
      />
      <van-field
        v-model="campus.contactPhone"
        label="联系电话"
        type="tel"
        maxlength="11"
        :formatter="(v)=>v.replace(/[^0-9]/g, '')"
        placeholder="请输入校区电话/手机号"
      />
      <!-- <van-field
        class="campus-location"
        label="校区位置"
        placeholder="便于家长学员查找路线"
        name='city'
        readonly>
        <template #input>
          <div v-if="regionAddress" class="van-ellipsis">
            <van-icon name="clear" @click.stop="clearLocation()" class="clear-i"/>
            <span>{{regionAddress}}</span>
          </div>
        </template>
        <template #button>
          <div @click.stop="choiceLocation()" style="color: var(--c1)">
            <van-icon name="location" style="vertical-align: text-top; margin-right: calc(var(--gap) * 4);"/>
            <span>设置</span>
          </div>
        </template>
      </van-field> -->
      <van-field
        style="margin-bottom: calc(var(--gap) * 16);"
        v-model="campus.locationAddress"
        class="textarea_field"
        type="textarea"
        label="校区地址"
        maxlength="200"
        :border="false"
        :autosize="{maxHeight: '48'}"
        placeholder="详细街道楼牌号等信息补充"
      />
      <van-field style="display: block;">
        <template #label>
          <span>详细描述</span>
        </template>
        <template #input>
          <vx-mult-input
            v-model="campus.detailContent.list"
          ></vx-mult-input>
        </template>
      </van-field>
    </van-form>
    <pageFooterBtn :absolute="true" @click="submit" :loading="submiting" loading-text="提交中..."/>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: "bassCampusAdd",
  components: {
    pageFooterBtn,
  },
  data() {
    let type = this.$route.query.type,
      pageTitle,
      msg
    if (type == "add") {
      msg = "新增校区成功";
      pageTitle = "添加校区";
    } else if (type == "edit") {
      msg = "修改校区成功";
      pageTitle = "修改校区";
    }
    return {
      pageTitle: pageTitle,
      //type: "add" => 新增， "edit" => 编辑
      type: type,
      msg: msg,
      campus: {
        name: "",
        // headName: "",
        headId: null,
        contactName: "",
        contactPhone: '',
        locationCityCode: "",
        locationCityName: "",
        locationCountyCode: "",
        locationCountyName: "",
        locationProvinceCode: "",
        locationProvinceName: "",
        locationAddress: "",
        detailContent: {
          list: [{
            content:"",
            type:"text",
          }],
        },
      },
      submiting: false, // 提交中
    };
  },
  computed: {
    regionAddress () {
      let regionAddress = `${this.campus.locationProvinceName} ${this.campus.locationCityName} ${this.campus.locationCountyName}`;
      regionAddress = regionAddress.trim();
      return regionAddress
    },
  },
  methods: {
    /**
     * 跳转不同情况的机构收费
     * type：开通类型, 0 开通 1续费 2扩容
     */
    goto(type) {
      app.teacher.gotoOpenBuy({
        selfType: type
      })
    },
    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.submiting = true;
          this.campus.name = this.campus.name.trim();
          this.$api.postCampus(this.campus).then((res) => {
            if (res.code == 200) {
              this.$toast.success( this.msg );
              app.vue.$emit("campus-list-update");
              this.$router.back();
              this.$store.dispatch('queryUserInfo');
            } else if (res.code == 810000002) {
                // 机构未开通
                this.$dialog({
                  message: "试用期期间不能添加新校区，去开通服务吧",
                  showCancelButton: true,
                  confirmButtonText: "立即开通",
                }).then(() => {
                  this.goto(0);
                });               
              } else if (res.code == 810000003) {
                // 机构校区容量不够
                this.$dialog({
                  message: "机构校区容量已满，请前往扩容",
                  showCancelButton: true,
                  confirmButtonText: "校区扩容",
                }).then(() => {
                  this.goto(2);
                });               
              } else {
              this.$toast.fail( res.msg );
            }
          }).finally(()=>{
            this.submiting = false;
          })
        })
        .catch((err) => {
          if (Array.isArray(err)) {
            this.$refs.form.scrollToField(err[0].name);
            if (err[0].message) {
              this.$toast(err[0].message);
            }
          } else {
            // 危险通知
            this.$toast.fail( err );
          }
        });
    },
    choiceLocation() {
      let  {
          locationLongitude, 
          locationLatitude, 
          locationCityCode,
          locationCityName,
          locationCountyCode,
          locationCountyName,
          locationProvinceCode,
          locationProvinceName,
          locationAddress
        } = this.campus
      let opts = {};

      if (locationLongitude && locationLatitude) {
        // 如果已经有坐标，传入回显
        opts = {
          locationCityCode,
          locationCityName,
          locationCountyCode,
          locationCountyName,
          locationProvinceCode,
          locationProvinceName,
          locationAddress,
          // 必须要有坐标信息，才会回显
          locationLongitude,
          locationLatitude,
        }
      }

      app.x3.side.xsLocateAddress(opts).then(res=>{
        Object.assign(this.campus, res);
      })
    },
    clearLocation() {
      this.campus.locationCityCode = "";
      this.campus.locationCityName = "";
      this.campus.locationCountyCode = "";
      this.campus.locationCountyName = "";
      this.campus.locationProvinceCode = "";
      this.campus.locationProvinceName = "";
      this.campus.locationLongitude = "";
      this.campus.locationLatitude = "";
      this.campus.locationAddress = "";
    },
  },
  created() {
    if (this.type == "edit") {
      this.showLoading();
      this.$api.getCampus({
          campusId: this.$route.query.id,
      }).then((res) => {
        vant.Toast.clear();
        if (res.code === 200) {
          this.campus.id = res.data.id;
          this.campus.name = res.data.name;
          // this.campus.headName = res.data.headName;
          this.campus.headId = res.data.headId;
          this.campus.contactName = res.data.contactName || '';
          this.campus.contactPhone = res.data.contactPhone || '';
          this.campus.locationAddress = res.data.locationAddress || '';
          this.campus.locationCityCode = res.data.locationCityCode;
          this.campus.locationCityName = res.data.locationCityName || '';
          this.campus.locationCountyCode = res.data.locationCountyCode;
          this.campus.locationCountyName = res.data.locationCountyName || '';
          this.campus.locationProvinceCode = res.data.locationProvinceCode;
          this.campus.locationProvinceName = res.data.locationProvinceName || '';
          this.campus.locationLongitude = res.data.locationLongitude || '';
          this.campus.locationLatitude = res.data.locationLatitude || '';

          if (res.data.detailContent) {
            this.campus.detailContent = res.data.detailContent;
          } else {
            this.campus.detailContent = {
              list: [{
                content:"",
                type:"text",
              }
              // 测试语音用
              // , {
              //   env: app.base.env,
              //   type: "audio",
              //   localId: "weixin://resourceid/a3f1eacae5be209960ad761e7bc01bc2",
              //   mediaId: "M4Cv6LSUDZvRawnEe4z3Whzt2ScJUO0YKcwnzDWp61pvN6T4AVNFfuzAaYVNrRWL",
              //   url: "https://xgj-files.oss-cn-hangzhou.aliyuncs.com/uploads/x3/assets/test.mp3",
              //   duration: 7000,
              // }
              ],
            };
          }
        } else {
          this.$toast.fail( res.msg );
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.vf {
  height: calc(100% - 50px);
  overflow-y: auto;
  .campus-location {
    ::v-deep .van-field__label {
      width: 4.2em;
    }
  }
}
.clear-i {
  color: #C8C9CC;
  padding: calc(var(--gap) * 1) calc(var(--gap) * 8);
  vertical-align: text-bottom;
}
.btn {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>